import { createContext, useContext, useEffect, useState } from "react";
import { THEME_COLOR } from "../config/club";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [darkMode, setDarkMode] = useState(
    localStorage.getItem("darkMode") === "true"
  );

  useEffect(() => {
    const theme = darkMode ? "dark" : "light";

    // ✅ Tell Bootstrap to switch theme
    document.documentElement.setAttribute("data-bs-theme", theme);

    // Persist preference
    localStorage.setItem("darkMode", darkMode);

    // Your custom brand color
    document.documentElement.style.setProperty("--brand-color", THEME_COLOR);
  }, [darkMode]);

  return (
    <ThemeContext.Provider value={{ darkMode, setDarkMode }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);